import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Checkbox } from "@progress/kendo-react-inputs";
import { cloneElement } from "react";
import "../../styles/userManagement/userInputs.css";
import { getTranslation } from "../../common/translation";
import { useTranslation } from "react-i18next";

const UserDropdown = ({
  label,
  name,
  data,
  handleOpen,
  handleClose,
  handleChange,
  textField,
  disabled,
  errorMsgs,
  error,
  errors,
  open,
  value,
  dataItemKey
}) => {
  const { t } = useTranslation();
  const itemRender = (li, itemProps) => {
    const valueIds = value.map((item) => item[name]);
    const checkboxValue = () => {
      // if length of selected is equal to all options minus one,
      // then all area area selected
      return data[0]?.id === 0 && value.length === data?.length - 1
        ? true
        : valueIds.includes(itemProps.dataItem[name]);
    };

    const itemChildren = (
      <div className="d-flex gap-2 option m-1">
        <Checkbox value={checkboxValue()} />
        <p className="mb-0">{li.props.children}</p>
      </div>
    );
    return cloneElement(li, li.props, itemChildren);
  };
  return (
    <div className={`${error ? "error" : ""} col-12 col-md-6 mb-4`}>
      <label className={`mb-2 ${name === "branchId" ? "branch" : ""}`}>
        {getTranslation(label, t)}
      </label>
      {name === "roleId" ? (
        <DropDownList
          style={
            !error
              ? value.roleDescription === getTranslation("Select", t)
                ? { color: "var(--inchcape-light-grey)" }
                : { color: "var(--inchcape-dark-blue)" }
              : { color: "var(--inchcape-red)" }
          }
          onChange={handleChange}
          onOpen={handleOpen}
          onClose={handleClose}
          name={name}
          data={data}
          disabled={disabled}
          opened={open || false}
          value={value}
          textField={textField}
        />
      ) : (
        <MultiSelect
          data={data}
          className="k-input-flat"
          name={name}
          value={value}
          dataItemKey={dataItemKey}
          onOpen={handleOpen}
          onClose={handleClose}
          opened={open || false}
          onChange={handleChange}
          disabled={disabled}
          autoClose={false}
          textField={textField}
          placeholder={getTranslation("Select", t)}
          itemRender={itemRender}
          tags={
            data[0]?.id === 0 && value.length === data.length - 1
              ? [
                  {
                    text: getTranslation(`All`, t),
                    data: [...value]
                  }
                ]
              : undefined
          }
        />
      )}
      {name === "brandId" && errors.missingBrand && (
        <p>{errorMsgs.missingBrand}</p>
      )}
      {name === "marketId" && errors.missingMarket && (
        <p>{errorMsgs.missingMarket}</p>
      )}
      {!errors?.missingBrand && !errors?.missingMarket && error && (
        <p>{getTranslation(`Please add a ${name.slice(0, -2)}.`, t)}</p>
      )}
    </div>
  );
};

export default UserDropdown;
